module.exports = __webpack_public_path__ + "img/icon-desktop-monitor-remove.89eb1b12.svg";